// @flow
import * as React from 'react';
import { Box, Heading, AccordionPanel as GrommetAccordionPanel } from 'grommet';

type Props = {
    children: React.Node,
    label: React.Node,
};

const AccordionPanel = (props: Props) => {
    const { children, label } = props;

    return (
        <GrommetAccordionPanel
            label={(
                <Box pad={{ horizontal: 'medium', vertical: 'small' }}>
                    <Heading size="14px" weight={600}>
                        {label}
                    </Heading>
                </Box>
            )}
        >
            <Box background="white" pad={{ vertical: 'small' }}>
                {children}
            </Box>
        </GrommetAccordionPanel>
    );
};

export default AccordionPanel;
